import { availableTypes } from "@/shared/form/button/document-button/model/available-types";

export function checkPreviewIsAvailable(fileName?: string) {
  const extension = fileName?.split(".").pop();

  if (!extension) {
    return false;
  }

  return availableTypes.includes(extension);
}
